import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

export const LayoutHeroWithoutImage = {
  factory: EElement({
    id: '1298da94-13cc-4005-32c5-d3a6659d32d6',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('f1f0ef14-7aad-495c-2813-39a43bae998c')]),
      children: EList([
        EElement({
          id: '1298da94-13cc-4005-32c5-d3a6659d32d7',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'e5cf2737-4d74-4d9a-2c85-717a35171441',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('dd474cd3-ae25-d5ed-de00-845b30762057'),
                  ]),
                  children: EList([
                    EElement({
                      id: '3e92f91a-e215-258a-7ec5-7cc7e917a970',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Heading')
                      ),
                      data: ERecord({
                        tag: EEnum('h1'),
                        children: EList([
                          EElement({
                            id: '3e92f91a-e215-258a-7ec5-7cc7e917a971',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Title copy goes here'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'a77c24fd-0906-a11c-1bee-8875b8223098',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Paragraph')
                      ),
                      data: ERecord({
                        styleBlockIds: EList([
                          EText('1b2031fc-27bc-6bb0-9580-913bd9335308'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'cb947b89-e63a-24fc-4bd7-e289719ccee0',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText(
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem. Etiam sodales ac felis id interdum.'
                            ),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'fb5a6b94-8aed-5ef8-6004-ed56a42fe4b0',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Link')
                      ),
                      data: ERecord({
                        button: EBoolean(true),
                        eventIds: EList([]),
                        link: ELiteral({
                          name: qualify(
                            Plugins.name('Basic'),
                            typeName('Link')
                          ),
                          value: JSON.parse('{"mode":"external","url":"#"}'),
                        }),
                        block: EText(''),
                        styleBlockIds: EList([
                          EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'fb5a6b94-8aed-5ef8-6004-ed56a42fe4b1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Get Started'),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'f1f0ef14-7aad-495c-2813-39a43bae998c',
      type: 'class',
      name: 'Hero Without Image',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'dd474cd3-ae25-d5ed-de00-845b30762057',
      type: 'class',
      name: 'Hero Wrapper Two',
      comb: '',
      styleLess:
        'display: flex; max-width: 750px; margin-right: auto; margin-left: auto; flex-direction: column; justify-content: flex-start; align-items: center; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: '1b2031fc-27bc-6bb0-9580-913bd9335308',
      type: 'class',
      name: 'Margin bottom 24px',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
  ],
} as const;
